module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('sound')], 1), _vm._v(" "), _c('footer', [_vm._m(1), _vm._v(" "), _c('build', {
    staticClass: "right"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', [_vm._v("Sleep Sound")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left"
  }, [_vm._v("Based on "), _c('a', {
    attrs: {
      "href": "https://codepen.io/AngelaVelasquez/pen/cihEG"
    }
  }, [_vm._v("codepen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc1647e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 90
// module chunks = 1